<template>
  <div style="width:800px;height:800px;position:absolute;left:50%;top:50%;margin-left:-400px;margin-top:-400px;">
    <div class="login-content-box">
      <div class="login-content-box-1">
        <div class="login-content-box-1-top">
          <div class="f-tac" style="width:100%">
            <img src="@static/img/logo.png" style="display:inline-block;">
          </div>
          <p class="p2">主办登录</p>
        </div>
        <div class="login-content-box-1-bottom">
          <Form class="F" ref="formInline" :model="formInline" :rules="ruleInline" @keyup.enter.native="handleSubmit('formInline')">
            <FormItem class="F-1" prop="user" >
              <Input class="I" type="text" v-model="formInline.user" placeholder="用户名" prefix="md-contact"/>
            </FormItem>
            <FormItem class="F-1" prop="password">
              <Input class="I" type="password" v-model="formInline.password" placeholder="密码" prefix="md-lock" />
            </FormItem>
            <FormItem class="F-1" prop="captcha">
              <Input class="I" v-model="formInline.captcha" placeholder="验证码" prefix="md-mail-open"/>
              <img class="code" :src="code.image" alt="验证码" v-if="code && code.image" @click="getCode" />
            </FormItem>
            <div class="F-2">
              <Checkbox class="save-btn" v-model="remember">&nbsp;&nbsp;&nbsp;记住我</Checkbox> 
            </div>
            <Button type="primary" @click="handleSubmit('formInline')" size="large" :loading="loading">登录</Button> 
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  data () {
    return {
      formInline: {
        user: "",
        password: "", 
        captcha: ""
      },
      ruleInline: {
        user: [{ required: true, message: "用户为必填选项", trigger: "blur" }],
        password: [
          { required: true, message: "账号或密码错误", trigger: "blur" },
          {
            type: "string",
            min: 4,
            message: "密码不能小于4位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 50,
            message: "密码不能大于50位",
            trigger: "blur"
          }
        ],
        captcha: [{ required: true, message: "验证码必填", trigger: "blur" }]
      },
      code: null, // 二维码信息
      remember: false, // 记住我
      loading: false
    };
  },
  async created () {
    this.getCode();
    this.init();
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    })
  },
  methods: {
    ...mapMutations({
      setUser: "setUser",
      setRole: "setRole",
      setToken: "setToken",
      setTokenTime: "setTokenTime",
      setLogin: "setLogin",
      setCompany: "loginModule/setCompany",
      setExhibition: "loginModule/setExhibition"
    }),
    ...mapActions({
      getUser: "loginModule/getUser",
      getToken: "loginModule/getToken",
      getCompany: "loginModule/getCompany",
      getImgCode: "loginModule/getImgCode",
      validateImgCode: "loginModule/validateImgCode",
      getExhibitionById: "exhibitionModule/getExhibitionById",
      getDefaultJoinExhibition: "companyModule/getDefaultJoinExhibition"
    }),
    init () {
      let name = this.$cookies.get('host-name');
      let pwd = this.$cookies.get('host-pwd');
      if (name && pwd) {
        let password = CryptoJS.AES.decrypt(pwd, "GY-host-key").toString(CryptoJS.enc.Utf8);
        // console.log("解密结果：" + password);
        this.remember = true;
        this.formInline.user = name;
        this.formInline.password = password;
      }
    },
    async handleSubmit (name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let codeValid = await this.validCode();
      if (!codeValid) return;
      let formData = {
        grant_type: "password",
        client_id: "cloud.exhibition",
        client_secret: "secret",
        username: form.user,
        password: form.password,
        scope: "synair offline_access",
        require_role: "host"
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let tokenData = await this.getToken(formData);
      if (tokenData) {
        this.setRole(1);
        this.setToken(tokenData.access_token);
        this.setTokenTime(tokenData.expires_in * 1000 + new Date().getTime());
        let user = await this.getUser();
        // let company = await this.getCompany(user.id);
        // if (!company) {
        //   // this.$router.push("/host/register-company");
        //   this.$router.push("/host/login/alogin");
        //   this.$Message.success("未绑定公司信息！");
        //   return;
        // } else {
        //   this.setCompany(company);
        //   let exhibition = await this.getDefaultJoinExhibition(company.id);
        //   if (exhibition) {
        //     let exData = await this.getExhibitionById(exhibition.exhibitionId);
        //     this.setExhibition(exData);
        //   } 
        // }

        // 保存密码
        if (this.remember) {
          let pwd = CryptoJS.AES.encrypt(String(form.password), "GY-host-key").toString();
          // console.log("加密结果"+ pwd);
          this.$cookies.set("host-name", form.user, 60 * 60 * 24 * 7);
          this.$cookies.set("host-pwd", pwd, 60 * 60 * 24 * 7);
        } else {
          this.$cookies.remove("host-name");
          this.$cookies.remove("host-pwd");
        }

        this.$Message.success("登录成功");
        this.setLogin(true);
        this.$router.push("/host/project");
      }
      this.loading = false;
    },
    async getCode () {
      // 获取code
      this.code = await this.getImgCode();
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    async validCode () {
      // 验证code
      if (!this.code || !this.formInline.captcha) return false;
      let valid = await this.validateImgCode({
        Key: this.code.key,
        Code: this.formInline.captcha
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        this.$Message.error(valid.errors[0].description);
        this.getCode();
        return false;
      }
      return true;
    },
    linkEx () {
      location.href = "/#/exhibition/login/alogin";
    }
  }
};
</script>

<style lang="scss" scoped>
.login-content-box {
  width: 360px;
  height: 500px;
  background-color: #fff;
  border-radius: 2px;
  position: absolute;
  left: 50%;
  margin-left: -180px;
  display: flex;
  align-items: center;
  justify-content: center;
  &-1 {
    width: 360px;
    height: 500px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(139, 140, 140, 0.3);
    border-radius: 2px;
    position: relative;
    &-top {
      width: 263px;
      // height: 40px;
      position: absolute;
      top: 20px;
      left: 43px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .p1 {
        width: 91px;
        height: 17px;
        font-size: 18px;
        line-height: 16px;
        color: #808080;
        cursor: pointer;
        font-weight: bold;
      }
      .p2 {
        width: 100%;
        text-align: center;
        height: 19px;
        font-size: 18px;
        line-height: 16px;
        color: #b10042;
        cursor: pointer;
        font-weight: bold;
        font-size: 24px;
        color: #333;
      }
      .p3 {
        color: #808080;
        &:hover {
          color: #b10042;
        }
      }
    }
    &-bottom {
      width: 300px;
      height: 350px;
      position: absolute;
      top: 160px;
      left: 29px;
    }
  }
  .wx-icon {
    width: 22px;
    height: 22px;
    padding: 3px 5px;
    background-color: #3eb135;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
    img {
      width: 13px;
      height: 11px;
    }
  }
}
.F {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 350px;
  position: relative;
  &-1 {
    margin-top: 15px;
    margin-bottom: 0;
    .I {
      margin-top: 19px;
    }
  }
  .F-2 {
    width: 100%;
    height: 15px;
    line-height: 15px;
    display: flex;
    justify-content: space-between;
    margin: 24px 0;
    .F-2-text {
      width: 48px;
      height: 13px;
      font-size: 12px;
      color: #333;
      cursor: pointer;
    }
  }
  .wx-btn {
    margin-top: 20px;
  }
  .code {
    width: 70px;
    height: 26px;
    position: absolute;
    top: 22px;
    right: 8px;
    cursor: pointer;
  }
}
.login-content-text {
  position: absolute;
  left: -25%;
  bottom: 48%;
  color: #b10042;
  h3 {
    font-size: 50px;
    margin-bottom: 80px;
  }
  p {
    font-size: 20px;
    font-weight: bold;
  }
}
/deep/ .newPas {
  .ivu-modal-body {
    padding: 24px 0 0 16px;
  }
}
/deep/ .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
.button {
  width: 120px;
  height: 40px;
  background-color: #b10042;
  border-radius: 4px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto 40px;
  margin-bottom: 10px;
  cursor: pointer;
}
</style>